import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode, createBlock as _createBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1dcacce6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "confirmation-content" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "pi pi-exclamation-triangle mr-3",
  style: {"font-size":"2rem"}
}, null, -1))
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = {
  key: 0,
  class: "card"
}
const _hoisted_6 = { class: "field" }
const _hoisted_7 = { for: "submitUserId" }
const _hoisted_8 = { class: "field" }
const _hoisted_9 = { for: "submitPassword" }

import { ref, onMounted, onBeforeUnmount, computed, watch } from 'vue';
import i18n from '@/locale/i18n';
import { useAuthStore } from '@/store/auth';
import { FocusControl } from '@/utils/FocusControl';
import { ISubmitAuthComponent } from '@/interface/component/common/i-submit-auth-component';


export default /*#__PURE__*/_defineComponent({
  __name: 'SubmitAuthenticatorDialog',
  props: {
    visible: {
        type: Boolean,
        default: false
    },
    deleteFlag: {
        type: String,
        default: ""
    }
},
  emits: ['submitClick', 'update:visible', 'cancel-submit'],
  setup(__props, { emit }) {

const props = __props

const t = i18n.global.t;
const authStore = useAuthStore();

const displayFlag = ref();

const userId = ref('');
const password = ref('');
const email = ref(''); 





const submitPasswordRef = ref();

onMounted(() => {
    displayFlag.value = props.visible;
    userId.value = authStore.user?.userLoginId ?? '';
    email.value = authStore.user?.userEmail ?? '';
})

watch(() => props.visible, (newVal, oldVal) => {
    displayFlag.value = newVal;
});

const onSaveClick = () => {
    // emit('update:visible', false);
    // displayFlag.value = false;

    if (authStore.savePermission) {
        const data = {
            email: userId.value,
            inputBy: authStore.user?.userName ?? '',
            password: password.value,
            userLoginId: userId.value
        } as ISubmitAuthComponent;

        emit('submitClick', data);

    } else {
        const noAuth = {
            email: authStore.user!.userLoginId,
            inputBy: authStore.user!.userName,
            password: 'password',
            userLoginId: authStore.user!.userLoginId
        } as ISubmitAuthComponent;

        emit('submitClick', noAuth);
    }
    
    userId.value = authStore.user?.userLoginId ?? '';
    password.value = '';
}

const onCancelClick = () => {
    emit('update:visible', false);
    emit('cancel-submit');
    displayFlag.value = false;
    userId.value = authStore.user?.userLoginId ?? '';
    password.value = '';
}

const dialogClose = () => {
    emit('update:visible', false);
    displayFlag.value = false;
    userId.value = authStore.user?.userLoginId ?? '';
    password.value = '';
}

const inputCheck = computed(() => {
    if (!authStore.savePermission) {
        return false;
    }
    return !(userId.value.length > 0 && password.value.length > 0);
});

const focusNextByClass = (event: KeyboardEvent, targetClass: string) => {
    
    // let tabArr = [
    //     '.user-id', '.submit-password'
    // ];
    
    // let targetIndex = 0;
    
    // let currentIndex = tabArr.indexOf(currentClass);

    // if (event.shiftKey) {
    //     // shift 押下の場合
    //     let i = currentIndex - 1;
    //     targetIndex = i < 0 ? tabArr.length - 1 : i;
    // } else {
    //     let i = currentIndex + 1;
    //     targetIndex = i >= tabArr.length ? 0 : i;
    // }

    // let targetClass = tabArr[targetIndex];

    FocusControl.setNextFocusByClass(event, targetClass);
    if (targetClass === '.btn-save') {
        const el = document.getElementById('btnSave');
        el?.click();
    }
}

const submitDialogShow = () => {
    if (authStore.savePermission) {
        submitPasswordRef.value.focused = true;
    }
}


return (_ctx: any,_cache: any) => {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Password = _resolveComponent("Password")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createBlock(_component_Dialog, {
    header: _unref(t)("DIALOG.CONFIRMATION"),
    visible: displayFlag.value,
    "onUpdate:visible": _cache[4] || (_cache[4] = ($event: any) => ((displayFlag).value = $event)),
    onHide: dialogClose,
    class: "p-fluid input-top",
    onShow: submitDialogShow,
    breakpoints: { '960px': '75vw', '640px': '90vw' },
    style: { width: '450px' },
    modal: true
  }, {
    footer: _withCtx(() => [
      _createVNode(_component_Button, {
        label: _unref(t)('COMMON.BUTTON.CANCEL'),
        icon: "pi pi-times",
        onClick: onCancelClick
      }, null, 8, ["label"]),
      (__props.deleteFlag === 'delete')
        ? (_openBlock(), _createBlock(_component_Button, {
            key: 0,
            label: _unref(t)("COMMON.BUTTON.DELETE"),
            class: "btn-save",
            id: "btnSave",
            icon: "pi pi-check",
            onClick: onSaveClick,
            disabled: _unref(inputCheck)
          }, null, 8, ["label", "disabled"]))
        : (_openBlock(), _createBlock(_component_Button, {
            key: 1,
            label: _unref(t)('COMMON.BUTTON.SAVE'),
            class: "btn-save",
            id: "btnSave",
            icon: "pi pi-check",
            onClick: onSaveClick,
            disabled: _unref(inputCheck)
          }, null, 8, ["label", "disabled"]))
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        (__props.deleteFlag === 'delete')
          ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_unref(t)("COMMON.DIALOG.CONFIRM_MESSAGE_DELETE")), 1))
          : (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_unref(t)("COMMON.DIALOG.CONFIRM_MESSAGE_SAVE")), 1))
      ]),
      (_unref(authStore).savePermission)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("label", _hoisted_7, _toDisplayString(_unref(t)("COMMON.DIALOG.USER_ID")), 1),
              _createVNode(_component_InputText, {
                id: "submitUserId",
                type: "text",
                modelValue: userId.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((userId).value = $event)),
                class: "mb-3 user-id",
                autofocus: true,
                placeholder: _unref(t)("LOGIN.LOGIN_ID_PLACEHOLDER"),
                style: {"padding":"1rem"},
                onKeypress: _cache[1] || (_cache[1] = _withKeys(($event: any) => (focusNextByClass($event, '.submit-password')), ["enter"]))
              }, null, 8, ["modelValue", "placeholder"])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("label", _hoisted_9, _toDisplayString(_unref(t)("COMMON.DIALOG.PASSWORD")), 1),
              _createVNode(_component_Password, {
                ref_key: "submitPasswordRef",
                ref: submitPasswordRef,
                id: "submitPassword",
                modelValue: password.value,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((password).value = $event)),
                placeholder: _unref(t)("LOGIN.PASSWORD_PLACEHOLDER"),
                feedback: false,
                toggleMask: true,
                class: "w-full mb-3 submit-password",
                inputClass: "w-full",
                onKeypress: _cache[3] || (_cache[3] = _withKeys(($event: any) => (focusNextByClass($event, '.btn-save')), ["enter"])),
                inputStyle: "padding:1rem"
              }, null, 8, ["modelValue", "placeholder"])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["header", "visible"]))
}
}

})